var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import MuiCard from '@mui/material/Card';
import { fade } from '../styles/color-manipulator';
import { styled } from '../styled';
import { CardContext } from './card-context';
export var cardComponentName = 'QuantumCard';
export var Root = styled(MuiCard, {
    name: cardComponentName,
    slot: 'Root',
})(function (_a) {
    var theme = _a.theme, ownerState = _a.ownerState;
    var selectedBorderColor = theme.tokens.color_border_selected;
    var selectedStyle = {
        boxShadow: theme.mixins.borderAsBoxShadow(selectedBorderColor, 1),
        borderColor: selectedBorderColor,
        '&:hover': {
            boxShadow: theme.mixins.borderAsBoxShadow(selectedBorderColor, 1),
            borderColor: selectedBorderColor,
        },
        '&$disabled': {
            boxShadow: theme.mixins.borderAsBoxShadow(theme.tokens.color_border_disabled_selected, 2),
            borderColor: 'transparent',
        },
        '&:focus-visible': {
            boxShadow: "".concat(theme.mixins.borderAsBoxShadow(theme.tokens.color_border_focus_bold, 1), ", ").concat(fade(theme.tokens.color_border_focus_bold, 0.25), " 0px 0px 0px 0.25em"),
        },
    };
    var disabledStyle = {
        cursor: 'not-allowed',
        color: theme.tokens.color_fg_disabled,
        backgroundColor: theme.tokens.color_bg_disabled,
        '&:hover': {
            boxShadow: 'none',
        },
    };
    return __assign(__assign(__assign(__assign(__assign({}, (ownerState.button && __assign({
        borderColor: theme.tokens.color_border_default,
        cursor: 'pointer',
        transition: theme.transitions.create(['box-shadow', 'border-color'], {
            duration: theme.transitions.duration.shortest,
        }),
        '&:hover': theme.palette.mode === 'light'
            ? {
                boxShadow: theme.palette.mode === 'light' ? theme.shadows[1] : theme.shadows[2],
            }
            : {
                backgroundColor: fade(theme.palette.action.hoverBackground, 0.1),
                boxShadow: theme.shadows[1],
            },
        '&:focus': __assign({ outline: 'none' }, theme.mixins.focusRing()),
    }))), (ownerState.selectableButton && {
        cursor: 'pointer',
        transition: theme.transitions.create(['box-shadow', 'border-color'], {
            duration: theme.transitions.duration.shortest,
        }),
    })), (ownerState.selected && __assign({}, selectedStyle))), (ownerState.disabled && __assign({}, disabledStyle))), { borderRadius: ownerState.size === 'large' || ownerState.size === 'xlarge' ? 6 : 4, padding: {
            small: theme.spacing(2),
            medium: theme.spacing(3),
            large: theme.spacing(4),
            xlarge: theme.spacing(5),
        }[ownerState.size || 'large'] });
});
export var Card = React.forwardRef(function (props, ref) {
    var button = props.button, _a = props.component, component = _a === void 0 ? 'div' : _a, disabled = props.disabled, className = props.className, selected = props.selected, selectableButton = props.selectableButton, _b = props.size, size = _b === void 0 ? 'large' : _b, 
    // remove to prevent passing through to the root
    propClasses = props.classes, rootProps = __rest(props, ["button", "component", "disabled", "className", "selected", "selectableButton", "size", "classes"]);
    return (React.createElement(CardContext.Provider, { value: { size: size } },
        React.createElement(Root, __assign({}, { component: component }, { ownerState: {
                size: size,
                disabled: disabled,
                selectableButton: selectableButton,
                button: button,
                selected: selected,
            } }, rootProps, { className: className, role: button ? 'button' : undefined, tabIndex: button && !disabled ? 0 : undefined, "aria-disabled": disabled, ref: ref }))));
});
